var _style, _path, _g, _g2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTea({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8078;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#82BF67;}\n\t.st3{fill:#6BB055;}\n\t.st4{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.12,82.7l-2.27,0.74l-0.82,16.55l1.26,0.67c0,0,3.21,2.55,4.13-4.15c0.14-1,1.02-2.22,1.53-3.04 c1.05-1.68,2.47-3.42,4.4-4.09c1.51-0.53,3.08-0.2,4.42,0.61c4.16,2.5,4.82,6.83,4.06,11.35c-0.68,4.05-2.6,7.8-5.46,10.75 c-4.6,4.75-11.06,7.25-17.4,8.65c-0.65,0.14-1.31,0.28-1.97,0.4c4.17-11.48,7.59-26.41,6.19-42.61h-1.05 c0.93-0.55,1.42-1.11,1.42-1.71c0-3.53-18.05-6.38-40.31-6.38c-22.29,0-40.36,2.85-40.36,6.38c0,0.6,0.5,1.16,1.44,1.71h-1.33 c0,0-3.48,37.47,18.16,66.35c0,0,21.34,10.65,44.83-1.22c0,0,2.15-3.15,4.97-8.62c1.38-0.62,3.76-1.88,7.77-4.39 c0,0,25.92-10.65,28.2-24.07C166.93,106.58,174.42,74.39,145.12,82.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9,
    y: 76.62,
    className: "st1",
    width: 2.54,
    height: 5.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.02,
    y: 76.65,
    className: "st1",
    width: 2.54,
    height: 12.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.2,116.28c-12.08-12.62-10.68-33.56-10.68-33.56s20.98-0.47,33.06,12.15 c12.08,12.62,10.68,33.56,10.68,33.56S101.28,128.91,89.2,116.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M122.26,128.43L78.53,82.72c0,0-1.4,20.94,10.68,33.56C101.28,128.91,122.26,128.43,122.26,128.43z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.08,120.92c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTea);
export default __webpack_public_path__ + "static/media/Green_tea.3cf080f327fc314e864f7428f9306ad5.svg";
export { ForwardRef as ReactComponent };